import { makeAutoObservable } from 'mobx';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export interface IWebappsCid {
	id?: id;
	cid: id;
	yid?: string;
	name?: string;
	product_id?: string | number;
	product_name?: string;
}

export class WebappsCidModel implements IWebappsCid {
	id?: id;
	cid: id;
	yid?: string;
	name?: string;
	product_id?: string;
	product_name?: string;
	constructor(props?: Partial<IWebappsCid>) {
		this.id = props?.id;
		this.cid = props?.cid ?? '';
		this.yid = props?.yid ?? (props?.product_id != null ? String(props.product_id) : undefined);
		this.name = props?.name ?? props?.product_name;
		this.product_id = props?.product_id != null ? String(props.product_id) : this.yid;
		this.product_name = props?.product_name ?? props?.name ?? this.name;
		makeAutoObservable(this);
	}

	getId(): id | undefined {
		return this.id;
	}

	getCid(): id {
		return this.cid;
	}

	getYid(): string | undefined {
		return this.yid;
	}

	getName(): string | undefined {
		return this.name;
	}

	getProductId(): string | undefined {
		return this.yid;
	}

	getProductName(): string | undefined {
		return this.name;
	}
}
